import React from 'react'
import styled from 'styled-components'

import { FaRegCalendarAlt } from 'react-icons/fa'
import Picker from './picker'

import { FONTS } from '../../constants'

export const CustomDatePicker = (props) => {
  return (
    <Root>
      <DatePicker
        showMonthDropdown
        showYearDropdown
        popperPlacement={ props.popperPlacement }
        popperModifiers={ {
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
          } }
        }
        placeholderText={ props.placeholder || 'DD/MM/YYYY' }
        { ...props }
      />
      <FaRegCalendarAlt />
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  position: relative;

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  svg {
    position: absolute;
    font-size: 16px;
    top: 6px;
    right: 6px;
    color: #DADADA;
  }
`

const DatePicker = styled(Picker)`
    width: 100%;
    height: 30px;
    border: 1px solid #C4C4C4;
    border-radius: 4px;
    padding: 6px 32px 6px 12px;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #333333;

    ::placeholder {
      color: #C4C4C4;
    }
  
    ${p => p.invalid && `
        border-color: #dc3545;

        :focus {
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }
    `}

    :focus {
      outline: none;
      box-shadow: none;
    }

    :disabled {
      background: #EAEAEA;
      color: #808080;
    }

    ::placeholder {
      color: #C4C4C4 !important;
    }
`



// WEBPACK FOOTER //
// ./src/components/datepicker/datepicker.js